<template>
    <div @click="chooseFrequency" :class="{ 'active': isActive }" class="frequency">
        <div class="frequency-label">
            <div class="radio-button">
                <div class="radio-button-active"></div>
            </div>
            <div class="frequency-name">{{ frequency.name }}</div>
        </div>
        <span class="frequency-discount" v-if="hasDiscount">
            <span class="discount-content" v-if="frequency.amount > 0">Save ${{frequency.amount}}</span>
            <span class="discount-content" v-else>Save {{frequency.percent}}%</span>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            frequency: {
                type: Object,
                required: true
            },
            isActive: {
                type: Boolean
            }
        },
        methods: {
            chooseFrequency(event) {
                this.$emit('click', event)
            }
        },
        computed: {
            hasDiscount() {
                if (this.frequency.amount > 0 ||
                this.frequency.percent > 0) {
                    return true
                }
                return false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .frequency {
        border-radius: var(--input-border-radius);
        border: 1px solid #E5E9EF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        white-space: nowrap;
        height: 44px;
        padding: 0 10px 0 14px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:not(.active) {
            cursor: pointer;
        }

        &.active {
            border: 1px solid var(--color-primary);

            .radio-button {
                border: 1px solid var(--color-primary) !important;

                .radio-button-active {
                    background-color: var(--color-primary);
                    width: 10px;
                    height: 10px;
                    border-radius: 100px;
                }
            }

            .frequency-name {
                color: var(--color-primary);
            }
        }

        .frequency-label {
            display: flex;
            align-items: center;
            gap: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .frequency-name {
                color: #8492A6;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .radio-button {
                display: flex;
                justify-content: center;
                align-items: center;
                min-width: 16px;
                width: 16px;
                height: 16px;
                border-radius: 100px;
                border: 1px solid #E5E9EF;
            }
        }

        .frequency-discount {
            padding: 0 8px;
            border-radius: calc(var(--input-border-radius) - 4px);
            background-color: #f2f2f2;
            height: 24px;
            display: flex;
            align-items: center;

            .discount-content {
                color: var(--color-primary);
                font-weight: 500;
                font-size: 11px;
                line-height: 1;
            }
        }
    }
</style>
